import { createReducer } from 'typesafe-actions';

import { IPayoutState, TPayoutAction, PayoutActionTypes } from '@/store/types/payout.types';

const initialState: IPayoutState = {
  payout: null,
  error: undefined,
  isLoading: false,
};

export const payoutReducer = createReducer<IPayoutState, TPayoutAction>(initialState)
  .handleType(PayoutActionTypes.MAKE_PAYOUT, (state) => ({
    ...state,
    isLoading: true,
    error: undefined,
  }))

  .handleType(PayoutActionTypes.MAKE_PAYOUT_SUCCESS, (state, action) => {
    return {
      ...state,
      payout: action.payout,
      isLoading: false,
      error: undefined,
    };
  })

  .handleType(PayoutActionTypes.MAKE_PAYOUT_FAIL, (state, action) => {
    return {
      ...state,
      isLoading: false,
      error: action.error,
    };
  });
